/* @flow */
import React from 'react';

import BirthdateModalSectionMixin from 'chat/components/mixins/BirthdateModalSectionMixin.jsx';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import UserActions from 'user/UserActions';

/**
 * The actual render is in BirthdateModalSectionMixin
 */
/* eslint-disable react/require-render-return */
const AskForParentEmail = React.createClass({
  mixins: [
    BirthdateModalSectionMixin,
    LinkedStateMixin,
  ],

  getInitialState() {
    return {
      parentEmail: '',
      error: null,
    };
  },

  onSubmit() {
    UserActions.setParentEmail(this.state.parentEmail).catch(error => {
      // TODO: FIX THIS. This doesn't belong here.
      this.setState({ error: error.field_errors[0].messages[0] });
    });
  },

  getSubtext() {
    return 'In order to keep using Remind, we’ll need to notify a parent.';
  },

  buttonDisabled() {
    return false;
  },

  title() {
    return 'Please enter your parent’s email';
  },

  renderCollector() {
    const { error } = this.state;

    return (
      <div>
        <Label htmlFor="">
          {'Parent’s email'}
        </Label>
        <Input type="text" valueLink={this.linkState('parentEmail')} />
        {error && <span className="BirthDateModal-error">{error}</span>}
      </div>
    );
  },
});

export default AskForParentEmail;



// WEBPACK FOOTER //
// ./src/chat/components/AskForParentEmail.jsx